import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Card, Grid, List, ListItem, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function Summary({ bulkUploadSummaryData, subscriptionData }) {
  const {
    numberOfUsersBeingCreated,
    newTeams = [],
    newPermissionProfiles = [],
    excludedUsers = [],
  } = bulkUploadSummaryData;

  const listStyle = {
    marginBottom: 2,
    paddingLeft: 8,
    paddingRight: 8,
    width: "100%",
    bgcolor: "background.paper",
    position: "relative",
    overflow: "auto",
    maxHeight: 300,
    "& ul": { padding: 0 },
  };

  return (
    <MDBox>
      <MDTypography variant="h4" mx={2} my={2} color="primary">
        SUMMARY
      </MDTypography>

      <MDBox sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <MDTypography variant="h5" mx={2} my={3} textAlign="center" color="success">
          Count of the users being created:
        </MDTypography>
        <MDTypography variant="h5" ml={2}>
          {numberOfUsersBeingCreated || 0}
        </MDTypography>
      </MDBox>
      {subscriptionData?.seatCount ? (
        <MDTypography variant="h5" mx={2} my={1} color="success" textAlign="center">
          {numberOfUsersBeingCreated}/{subscriptionData.seatCount} active licenses will be used
        </MDTypography>
      ) : null}

      <Grid container spacing={2} my={3}>
        <Grid item xs={12} md={6} lg={4}>
          <Card sx={{ height: "100%" }}>
            <MDTypography variant="h5" textAlign="center" color="success" my={2}>
              New Teams being created
            </MDTypography>
            <List sx={listStyle} subheader={<li />}>
              {newTeams.map((item) => (
                <ListItem key={`team-${item}`} alignItems="center">
                  <ListItemText primary={item} />
                </ListItem>
              ))}
            </List>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Card sx={{ height: "100%" }}>
            <MDTypography variant="h5" textAlign="center" color="success" my={2}>
              New Permissions Profiles being created
            </MDTypography>
            <List sx={listStyle} subheader={<li />}>
              {newPermissionProfiles.map((item) => (
                <ListItem key={`permissionProfile-${item}`} alignItems="center">
                  <ListItemText primary={item} />
                </ListItem>
              ))}
            </List>
          </Card>
        </Grid>
        <Grid item xs={12} sm={8} lg={4}>
          <Card sx={{ height: "100%" }}>
            <MDTypography variant="h5" textAlign="center" color="error" my={2}>
              List of users being excluded
            </MDTypography>
            <List sx={listStyle} subheader={<li />}>
              {excludedUsers.map((item) => (
                <ListItem key={`user-${item}`} alignItems="center">
                  <ListItemText primary={item} />
                </ListItem>
              ))}
            </List>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Summary;

Summary.defaultProps = {
  bulkUploadSummaryData: {
    numberOfUsersBeingCreated: 0,
    newTeams: [],
    newPermissionProfiles: [],
    excludedUsers: [],
  },
};

Summary.propTypes = {
  bulkUploadSummaryData: PropTypes.shape({
    numberOfUsersBeingCreated: PropTypes.string,
    newTeams: PropTypes.arrayOf(),
    newPermissionProfiles: PropTypes.arrayOf(),
    excludedUsers: PropTypes.arrayOf(),
  }),
};
